import { formatDate } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AdminService } from "../admin.service";
import { Router } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-admin-add-payments",
  templateUrl: "./admin-add-payments.component.html",
  styleUrls: ["./admin-add-payments.component.css"],
})
export class AdminAddPaymentsComponent implements OnInit {
  addNotesForm!: FormGroup;
  token: any;
  minDate = new Date();

  constructor(
    private matdialogref: MatDialogRef<AdminAddPaymentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private router: Router,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.addNotesForm = this.formBuilder.group({
      date: ["", [Validators.required]],
      employee_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[a-zA-Z][a-zA-Z\\s]+$"),
        ]),
      ],
      notes: ["", [Validators.required]],
    });
  }
  close() {
    this.matdialogref.close();
  }
  public formatFormDate(date: Date) {
    return formatDate(date, "yyyy-MM-dd hh:mm", "en");
  }

  saveLog() {
    if (this.addNotesForm.valid) {
      const notesObj = {
        module_type: this.data.module_type,
        id: this.data._id,
        date: this.formatFormDate(this.addNotesForm.value.date),
        employee_name: this.addNotesForm.value.employee_name,
        notes: this.addNotesForm.value.notes,
      };

      this.services.addNotes(notesObj, this.token).subscribe(
        (response: any) => {
          if (response.status == 201 || response.status == 200) {
            this.matdialogref.close();
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
    } else {
      this.addNotesForm.markAllAsTouched();
    }
  }
}
